import React from 'react';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useAuthContext } from 'context/AuthContext';
import { getSafeRedirectPath } from 'config/routes';

const GuestRoute: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  const [searchParams] = useSearchParams();
  if (isAuthenticated) {
    return <Navigate to={getSafeRedirectPath(searchParams.get('next'))} replace />;
  }
  return <Outlet />;
};

export default GuestRoute;
